import { useEffect } from "react";
import type { ReactNode } from "react";
import Panel from "./Panel";

// Modals reuse the window-chrome Panel, so a dialog reads as the same object as
// a card - just floated over a scrim.
export default function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  className,
}: {
  open: boolean;
  title?: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}) {
  useEffect(() => {
    if (!open) return;

    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="bg-ink/50 fixed inset-0 z-80 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className={`animate-scale-up w-full max-w-lg ${className ?? ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <Panel title={title} onClose={onClose}>
          {children}
          {footer && (
            <div className="mt-6 flex justify-end gap-3">{footer}</div>
          )}
        </Panel>
      </div>
    </div>
  );
}
